import { render, staticRenderFns } from "./ThemeSwitch.vue?vue&type=template&id=a725597e&scoped=true"
import script from "./ThemeSwitch.vue?vue&type=script&lang=js"
export * from "./ThemeSwitch.vue?vue&type=script&lang=js"
import style0 from "./ThemeSwitch.vue?vue&type=style&index=0&id=a725597e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a725597e",
  null
  
)

export default component.exports